import UrlParam from "sps-shared/dist/types/enums/UrlParam";
import getUrlParams from "utils/url/getUrlParams";

export default function getUrlParam(paramKey: UrlParam) {
  return getUrlParams().get(paramKey);
}
